import { render } from "./UnderConstruction.vue?vue&type=template&id=f8d6f744&scoped=true"
import script from "./UnderConstruction.vue?vue&type=script&lang=js"
export * from "./UnderConstruction.vue?vue&type=script&lang=js"

import "./UnderConstruction.vue?vue&type=style&index=0&id=f8d6f744&scoped=true&lang=css"

import exportComponent from "/Users/sung-hojang/git-projects/jpworldpay-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8d6f744"]])

export default __exports__